import { Action, createReducer, on } from '@ngrx/store';
import { Usuario } from '../../types/usuario.types';
import * as AuthActions from './auth.actions';

export const featureKey = 'auth';

export interface UserPermissionsState {
  pvgeo: boolean;
  ouvCollab: boolean;
}
export interface PublicTokensState {
  authToken: string;
  tnToken: string;
}

export interface State {
  isLoadingUser: boolean;
  isLoadingPublicTokens: boolean;
  isLoadingOUVLayers: boolean;
  user: Usuario | null;
  userPermissions: UserPermissionsState | null;
  publicTokens: PublicTokensState | null;
  error: any;
}

const initialState: State = {
  isLoadingUser: false,
  isLoadingPublicTokens: false,
  isLoadingOUVLayers: false,
  publicTokens: null,
  user: null,
  userPermissions: null,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.userLogin, AuthActions.userCheckLogged, (state) => ({
    ...state,
    isLoadingUser: true,
  })),
  on(AuthActions.userLoginSuccess, (state, { user }) => ({
    ...state,
    isLoadingUser: false,
    user,
    layerState: null,
    error: null,
  })),
  on(
    AuthActions.getUserPermissionSuccess,
    (state, { permissions: { pvgeo, ouvCollab } }) => ({
      ...state,
      userPermissions: {
        pvgeo,
        ouvCollab,
      },
    })
  ),
  on(AuthActions.getPublicTokens, (state) => ({
    ...state,
    isLoadingPublicTokens: true,
  })),
  on(AuthActions.getPublicTokensSuccess, (state, { publicTokens }) => ({
    ...state,
    isLoadingPublicTokens: false,
    publicTokens,
  })),
  on(AuthActions.getOUVLayers, (state) => ({
    ...state,
    isLoadingOUVLayers: true,
  })),
  on(AuthActions.getOUVLayersSuccess, (state) => ({
    ...state,
    isLoadingOUVLayers: false,
  })),
  on(AuthActions.userLoginFail, (state, { error }) => ({
    ...state,
    isLoadingUser: false,

    user: null,
    layerState: null,
    error,
  })),
  on(AuthActions.userLogout, (state) => ({
    ...state,
    isLoadingUser: false,
    user: null,
    layerState: null,
    error: null,
  })),
  on(AuthActions.userCheckLoggedSuccess, (state, { user }) => ({
    ...state,
    isLoadingUser: false,
    user,
    error: null,
  })),
  on(AuthActions.userCheckLoggedFail, (state) => ({
    ...state,
    isLoadingUser: false,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return authReducer(state, action);
}

export const getIsLoadingUser = (state: State) => state.isLoadingUser;
export const getIsLoadingPublicTokens = (state: State) =>
  state.isLoadingPublicTokens;
export const getIsLoadingOUVLayers = (state: State) => state.isLoadingOUVLayers;
export const getUser = (state: State) => state.user;
export const getUserPermissions = (state: State) => state.userPermissions;
export const getPublicTokens = (state: State) => state.publicTokens;
export const getAuthError = (state: State) => state.error;
